export const REMOVE_BUTTON_CLASSNAME = 'remove-button';
export const MIN_QUERY_LENGTH = 2;
export const SEARCH_TITLE_CLASSNAME = 'global-search-title';
export const SEARCH_INPUT_CLASSNAME = 'global-search-input';
export const DROPDOWN_OVERLAY_CLASSNAME = 'global-search-dropdown-overlay';
export const STOP_SCROLL_CLASSNAME = '--gs-stop-scroll';
